<div id="teacher-classes-index" class="container margin-top-1">
    <div class="flex-center">
      {{ "action-not-avaible-yet" | translate }}
    </div>
</div>  